import { Link, useNavigate, useParams } from 'react-router-dom'
import { useGetQuery, usePostQuery } from 'hooks'
import { Button, Card, Tag, Title } from 'components'
import styled from 'styled-components'

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
`

const Label = styled.span`
  font-weight: 600;
  margin-right: 0.5rem;
  ${({ theme: { colors } }) => `color: ${colors('neutral')};`}
`

const Actions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`

const formatDate = (iso, allDay) => {
  if (!iso) return '—'
  if (allDay) return new Date(iso).toLocaleDateString([], { dateStyle: 'medium', timeZone: 'UTC' })
  return new Date(iso).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })
}

export const EventShow = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { data } = useGetQuery({ url: `/events/${id}` })
  const { post: deleteEvent } = usePostQuery({ url: `/events/${id}`, method: 'DELETE' })

  const event = data?.event
  if (!event) return null

  const handleDelete = async () => {
    await deleteEvent({})
    navigate('/events')
  }

  return (
    <Card>
      <Title level={2}>{event.name}</Title>

      {event.event_type === 'holiday' && (
        <Tag className="warning">Holiday</Tag>
      )}
      {event.all_day && <Tag>All Day</Tag>}

      {event.description && <p>{event.description}</p>}

      <Row>
        <Label>Start</Label>
        <span>{formatDate(event.start_time, event.all_day)}</span>
      </Row>
      {!event.all_day && (
        <Row>
          <Label>End</Label>
          <span>{formatDate(event.end_time, false)}</span>
        </Row>
      )}
      {event.recurrance_rule && event.recurrance_rule !== 'NONE' && (
        <Row>
          <Label>Repeats</Label>
          <span>{event.recurrance_rule}</span>
        </Row>
      )}
      {event.location && (
        <Row>
          <Label>Location</Label>
          <span>{event.location}</span>
        </Row>
      )}
      {event.address && (
        <Row>
          <Label>Place</Label>
          <Link to={`/places/${event.address.Location?.slug}`}>
            {event.address.Location?.name || event.address.name}
          </Link>
        </Row>
      )}
      {event.queue && (
        <Row>
          <Label>Queue</Label>
          <Link to={`/join/${event.queue.slug}`}>{event.queue.name}</Link>
        </Row>
      )}

      <Actions>
        <Button onPress={() => navigate(`/events/${event.id}/edit`)}>Edit</Button>
        <Button className="danger" onPress={handleDelete}>Delete</Button>
      </Actions>
    </Card>
  )
}
